/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Event_Trigger_IntroInputs */



/**
* | output |
* | --- |
* | "Runs this agent each time the connected system reports a change. Pick the connection and, if you like, which changes should count. Runs started this way alwa..." |
*
* @param {Agent_Event_Trigger_IntroInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_event_trigger_intro = /** @type {((inputs?: Agent_Event_Trigger_IntroInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Event_Trigger_IntroInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Startet diesen Agenten jedes Mal, wenn das verbundene System eine Änderung meldet. Wählen Sie die Verbindung und, falls gewünscht, welche Änderungen zählen sollen. So gestartete Läufe fragen immer, bevor sie etwas ändern.")
	return /** @type {LocalizedString} */ ("Runs this agent each time the connected system reports a change. Pick the connection and, if you like, which changes should count. Runs started this way always ask before changing anything.")
});